import { mdiDomain } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/shared/logic/administration"
import type { OrgaViewFrameContext } from "../../../../context"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "district",
  title: "Kehrbezirk",
  tooltip:
    "Liegenschaften, Wohneinheiten und Ansprechpartner im Kehrbezirk verwalten und ihre Zuordnungen pflegen.",
  icon: mdiDomain,
  routeSegment: "district",
  // Same projection as the registry read admission (kehrblatt.registry:view).
  getPages: (context) =>
    context.permissions.allows("kehrblatt.registry", "view")
      ? [
          {
            id: "district",
            title: "Kehrbezirk",
            path: "",
          },
        ]
      : [],
}
